<!-- 其他款项详情 -->
<template>
  <div class="other-expense-container">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getData"
    >
      <BillTable
        :data="list"
        :columns="columns"
      >
        <mtd-table-column
          v-if="showRemark"
          label="备注"
          min-width="100"
        >
          <template #default="{row}">
            <pre-paid-tip v-if="row.prepaidBill" />
            <span v-else>-</span>
          </template>
        </mtd-table-column>
      </BillTable>
    </van-list>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import List from 'vant/lib/list';
import BillTable from '@/components/BillTable';
import BillApi from '@/api/bill';
import STATUS from '@/constants/status';
import { formatAmount } from '@/util/filter';
import PrePaidTip from '@/views/bill/components/PrePaidTip';


const titles = ['', '预付款抵扣', '分期购抵扣', '成本摊销', '调整款项'];
export default {
  name: 'OtherExpenseDetail',
  components: {
    BillTable,
    PrePaidTip,
    [List.name]: List,
  },
  data() {
    return {
      type: 1, // 1：预付款抵扣，2：分期购抵扣，3：成本摊销，4：调整款项
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      list: [],
      allColumns: [
        {
          type: '1,3',
          label: '日期',
          prop: 'date',
          fixed: true,
        },
        {
          type: '4',
          label: '调账类型',
          prop: 'adjustType',
        },
        {
          type: '1,3',
          label: '门店名称',
          prop: 'poiName',
        },
        {
          type: '1',
          label: '抵扣金额（元）',
          prop: 'deductedAmount',
          formatter(row) {
            return formatAmount(row.deductedAmount);
          },
        },
        {
          type: '3',
          label: '摊销金额（元）',
          prop: 'amortizationAmount',
          formatter(row) {
            return formatAmount(row.amortizationAmount);
          },
        },
        {
          type: '4',
          label: '调整金额（元）',
          prop: 'adjustAmount',
          formatter(row) {
            return formatAmount(row.adjustAmount);
          },
        },
      ],
    };
  },
  computed: {
    ...mapState('billModule', ['customerId']),
    columns() {
      return this.allColumns.filter((column) => column.type.includes(this.type));
    },
    showRemark() {
      if (this.list && this.list.length > 0) {
        return this.list.some((item) => item.prepaidBill);
      }
      return false;
    },
  },
  mounted() {
    const { type } = this.$route.query;
    this.type = Number(type);
  },
  methods: {
    async getData() {
      const { settleUnitId, cutMonth, settleUnitMode } = this.$route.query;
      const params = {
        customerId: this.customerId,
        settleUnitId,
        settleUnitMode,
        month: cutMonth,
        type: this.type,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      const res = await BillApi.getOtherExpenseDetail(params);
      if (res.code === STATUS.SUCCESS && res.data) {
        const { isFinished = true, content } = res.data;
        this.list = this.list.concat(content || []);
        this.finished = isFinished;
        if (!this.finished) {
          this.pageNum += 1;
        }
      } else {
        this.error = true;
      }
      this.loading = false;
    },
  },
  beforeRouteEnter(to, from, next) {
    const type = to.query.type;
    document.title = titles[type];
    next();
  },
};
</script>
